//@ts-check
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { errorHandler } from '../ajax';
import createBatchAction from '@/common/lib/create-batch-action';
import { STATUS_FAILURE_NOT_AUTHORIZED } from '@/common/constants';
import { openFailedDialog } from '@/common/components/kf-dialog';

export const loginRequest = createBatchAction('@@login/LOGIN_REQUEST', () => [showLoading()]);
export const loginSuccess = createBatchAction('@@login/LOGIN_SUCCESS', () => [hideLoading()]);
export const loginFailure = createBatchAction('@@login/LOGIN_FAILURE', (err) => [
  hideLoading(), 
  err.status == STATUS_FAILURE_NOT_AUTHORIZED ? openFailedDialog('メールアドレスまたはパスワードが間違っています。') : errorHandler(err)
]);
